import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/log-out-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-5a356b1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "containerRef",
  class: "avatar-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "right-block" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "small-text job-title" }
const _hoisted_6 = {
  key: 1,
  class: "dropdown"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Log out"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.user)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "avatar",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }, [
          _createElementVNode("img", {
            class: "left-block",
            src: _ctx.user.image,
            alt: "Your avatar"
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.user.first_name) + " " + _toDisplayString(_ctx.user.last_name), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.user.position), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMenuVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "dropdown__logout",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('facilitator_tools.log_out')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}